import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
              关于我们
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link to="/about" className="text-base text-gray-500 hover:text-gray-900">
                  公司简介
                </Link>
              </li>
              <li>
                <Link to="/team" className="text-base text-gray-500 hover:text-gray-900">
                  团队介绍
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
              服务
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link to="/services" className="text-base text-gray-500 hover:text-gray-900">
                  企业服务
                </Link>
              </li>
              <li>
                <Link to="/talent" className="text-base text-gray-500 hover:text-gray-900">
                  人才服务
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
              法律
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link to="/privacy" className="text-base text-gray-500 hover:text-gray-900">
                  隐私政策
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-base text-gray-500 hover:text-gray-900">
                  服务条款
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
              联系我们
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link to="/contact" className="text-base text-gray-500 hover:text-gray-900">
                  联系方式
                </Link>
              </li>
              <li>
                <Link to="/feedback" className="text-base text-gray-500 hover:text-gray-900">
                  意见反馈
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-200 pt-8">
          <p className="text-base text-gray-400 text-center">
            © {new Date().getFullYear()} 校园连接平台. 保留所有权利.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 